import React from 'react';
import { constants } from 'src/utils/const';

export const CopyToClipboardIcon = ({ value }: { value: string }) => {
  const [isCopied, setIsCopied] = React.useState(false);

  return (
    <span
      onClick={(e) => {
        e.stopPropagation();
        constants.copyToClipboard(value);
        setIsCopied(true);
        setTimeout(() => setIsCopied(false), 500);
      }}
      style={{
        marginLeft: '8px',
        cursor: 'pointer',
        transition: 'color 0.2s ease',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <i
        className="fa fa-clone"
        aria-hidden="true"
        style={{
          color: isCopied ? '#28a745' : '#6f42c1',
          transition: 'color 0.2s ease',
        }}
      ></i>
    </span>
  );
};